import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex items-center text-black text-lg" }
const _hoisted_2 = { class: "bg-white dark:bg-gray-900" }
const _hoisted_3 = { class: "py-8 px-4 mx-auto max-w-2xl lg:py-16" }
const _hoisted_4 = { action: "#" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = {
  for: "nome",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_7 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = {
  for: "telefono",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_10 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_11 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_12 = {
  key: 0,
  style: {"margin-top":"2%"},
  class: "w-full"
}
const _hoisted_13 = {
  for: "confidenzialità",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_16 = { class: "flex justify-between" }

import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import { ref, onMounted } from "vue";
import { Contatti, Data } from "@/../../EshJSLib/models/patient";
import ErrorModal from '@/views/Components/ErrorModal.vue';
import AlertModal from "@/components/AlertModalFeedback.vue";
import { Modal } from "flowbite-vue";
import {VueTelInput} from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import { capitaliseFirstLetter } from "@/../../EshJSLib/services/relatedFunction";


export default /*#__PURE__*/_defineComponent({
  __name: 'emergenzaCreate',
  emits: ["cancel"],
  setup(__props, { expose: __expose, emit }) {

const store = patientStore();
const { patient } = storeToRefs(store);
let errors = ref([]); 


let row = ref({} as Contatti);
const alertConfirmMessage = ref<null | string>(null);
let resolvePromise: (value: PromiseLike<boolean> | boolean) => void;
const modalType = ref<"confirm" | "alert">("confirm");
const showConfirm = ref(false);

// const props = defineProps<{
//   patient: Data;
//   index: number;
// }>();

const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const showLoading = ref(false);
const errorModal = ref(false);

const capitalise = () => {
  row.value.contatto_nominativo = capitaliseFirstLetter(row.value.contatto_nominativo);
};

function validateContact(contact, errorMessage) {
  const errorsl = [];

  const fieldsToCheck = [
    { field: contact.contatto_nominativo, errorMessage },
    { field: contact.contatto_telefono, errorMessage },
    { field: contact.id_livello_confidenzialita, errorMessage }
  ];

  fieldsToCheck.forEach(fieldInfo => {
    errorsl.push(!fieldInfo.field ? errorMessage : '');
  });
  errorsl.push(!validatePhoneNumber()? 'Il numero di telefono non è valido!' : '');
  

  console.log(contact);
  errors.value = errorsl;
  return errorsl.filter(error => error !='').length > 0;
}


function validatePhoneNumber() {
  if (!row.value.contatto_telefono )
    return false;
    //eslint-disable-next-line
    const regex1 = /([0-9\s\-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;


  if ( !regex1.test(row.value.contatto_telefono.replaceAll(/\s/g,''))) {
    return false;
  }
  return true;
}

function openModal(message: string, alertModal: boolean, rowData?: Contatti) {
  errors.value = [];
  row.value = rowData;
  alertConfirmMessage.value = message;
  alertModal ? (modalType.value = "alert") : (modalType.value = "confirm");
  showConfirm.value = true;
  return new Promise((resolve) => {
    resolvePromise = resolve;
  });
}

function checkContatto() {
  if(validateContact(row.value, 'Questo campo è obbligatorio') == true) {
    return false;
  }
  handleUserInput(true);
 
}

function handleUserInput(value: boolean) {
  store.fetchEmergencyContact();
  if (!resolvePromise) return;
  resolvePromise(value);
  showConfirm.value = false;
}


__expose({ openModal });


return (_ctx: any,_cache: any) => {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showConfirm.value)
      ? (_openBlock(), _createBlock(_unref(Modal), {
          key: 0,
          size: "2xl",
          onClose: _cache[5] || (_cache[5] = ($event: any) => (handleUserInput(false)))
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(alertConfirmMessage.value)), 1)
          ]),
          body: _withCtx(() => [
            _createElementVNode("section", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("form", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("Nome contatto: ")), 1),
                    _withDirectives(_createElementVNode("input", {
                      id: "emergencyContact",
                      class: _normalizeClass([{ 'border-red-500': _unref(errors)[0] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"]),
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(row).contatto_nominativo) = $event)),
                      onInput: capitalise
                    }, null, 34), [
                      [_vModelText, _unref(row).contatto_nominativo]
                    ]),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(errors)[0]), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("Telefono:")), 1),
                    _createVNode(_unref(VueTelInput), {
                      id: "emergencyPhone",
                      inputOptions: { placeholder: 'Inserisci il numero di telefono' },
                      mode: "international",
                      modelValue: _unref(row).contatto_telefono,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(row).contatto_telefono) = $event)),
                      defaultCountry: 'IT',
                      disabledFetchingCountry: false,
                      disabled: false,
                      disabledFormatting: false,
                      enabledCountryCode: false
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(errors)[1]), 1),
                    _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(errors)[3]), 1)
                  ]),
                  (_unref(row).id_contatto == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t(" Livello di confidenzialità * ")), 1),
                        _withDirectives(_createElementVNode("select", {
                          class: _normalizeClass([{ 'border-red-500': _unref(errors)[2] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
                          id: "confidenzialità",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(row).id_livello_confidenzialita) = $event))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).liveli_confidencialita, (item, key) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.id_livello_confidenzialita,
                              key: key
                            }, _toDisplayString(item.confidenzialita_descrizione), 9, _hoisted_14))
                          }), 128))
                        ], 2), [
                          [_vModelSelect, _unref(row).id_livello_confidenzialita]
                        ]),
                        _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(errors)[2]), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (handleUserInput(false))),
                type: "button",
                class: "mt-4 text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
              }, _toDisplayString(_ctx.$t("Annulla")), 1),
              _createElementVNode("button", {
                id: "submitEmergenza",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (checkContatto())),
                type: "button",
                class: "mt-4 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              }, _toDisplayString(_ctx.$t("salva contatto")), 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(AlertModal, {
      ref_key: "alertModal",
      ref: alertModal
    }, null, 512),
    (showLoading.value)
      ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})